var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Success = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsxs("svg", __assign({ width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: [_jsx("path", { d: 'M12 13V15', stroke: '#33840C', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }), _jsx("path", { d: 'M12.5 9C12.5 9.27614 12.2761 9.5 12 9.5C11.7239 9.5 11.5 9.27614 11.5 9C11.5 8.72386 11.7239 8.5 12 8.5C12.2761 8.5 12.5 8.72386 12.5 9Z', stroke: '#33840C' }), _jsx("path", { d: 'M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z', stroke: '#33840C', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' })] })));
};
export { Success };
//# sourceMappingURL=Success.js.map